import {
    GdprAdsPrefsOptions,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default function saveConsentString(consentString: string) {
    const currentOptions = getOptionsForFeature<GdprAdsPrefsOptions>(
        OwsOptionsFeatureType.GdprAdsPrefs
    );

    const newOptions = {
        ...currentOptions,
        consentString,
    };

    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.GdprAdsPrefs,
        newOptions
    );
}
